import StateSwitch from "@/components/StateSwitch";
import AppIcon from "@/components/AppIcon.vue";
import AppPopover from "@/components/AppPopover";
export default {
  name: "PpcBASBPortfolioCell",
  emits: ["state-change"],
  components: {
    AppIcon,
    StateSwitch,
    AppPopover
  },
  props: {
    state: {
      type: (Boolean, String),
      default: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    item_id: {
      type: String,
      default: ""
    }
  },
  computed: {
    State: {
      get() {
        return this.state;
      },
      set(val) {
        this.$emit('state-change', val);
      }
    }
  }
};